/**
 * Who an owner may write a disclosure rule for, and which fields it may
 * withhold — OND-79.
 *
 * THE CEILING AND THE FILTER ARE DIFFERENT AXES, and this file is the second.
 * `WORK_VISIBILITIES` in `visibility.ts` is one ORDERED scale saying how far a
 * work travels; these are a set of audiences saying who sees which line of its
 * history and which fields of it. There is no comparison to write between two
 * audiences and none should ever be added — 20261005098000 said it first: "The
 * rungs are *how far*, and OND-79's audience types are *who*."
 */
/**
 * The audiences an owner may write an override for.
 *
 * FOUR, AND THE ESTATE IS NOT ONE. The owner's carve-out of 30 September 2026:
 * an estate sees the full record of works attributed to its artist and the
 * owner cannot switch that off (OND-66), so offering an override against that
 * audience would promise a control the estate rule overrides anyway. The
 * database agrees — `ondo.disclosure_audience` has no estate label — and the
 * estate is a FLOOR in `ondo.disclosure_floor_entry_ids()` instead.
 *
 * `institution` IS WHAT THE TICKET CALLS "museums", and the name is the schema
 * being honest rather than a rename. `ondo.org_type` has no `museum`:
 * `ondo.capacity_for_org_type()` maps `institution`, `conservator`, `expert`
 * and `auction` all to `verifier`, so this is the finest grain the capacity
 * model has. `DISCLOSURE_AUDIENCE_LABELS` says so on the screen rather than
 * letting an owner discover the breadth later.
 *
 * UNORDERED. The array's order is the order the panel draws them in and
 * nothing else reads it — unlike `WORK_VISIBILITIES`, where the order IS the
 * meaning.
 *
 * These values must stay in step with the `ondo.disclosure_audience` enum in
 * supabase/migrations/20261005099000_the_owner_says_who_sees_which_line.sql.
 * Nothing enforces it but this comment and `supabase/tests/rls.sh`, which pins
 * the enum's labels.
 */
export const DISCLOSURE_AUDIENCES = [
    "collector",
    "gallery",
    "institution",
    "agent",
];
export function isDisclosureAudience(value) {
    return (typeof value === "string" &&
        DISCLOSURE_AUDIENCES.includes(value));
}
/**
 * The fields a rule may withhold.
 *
 * SIX, AND THEY ARE NAMED FOR WHAT AN OWNER WOULD WITHHOLD rather than for
 * columns. `insuredAmount` covers two database columns, because a sum without
 * its currency is a number nobody can act on; `documents` covers none at all —
 * it is the attachments, which is why hiding it has to reach the storage bucket
 * as well as the row.
 *
 * The list is what the two tickets name and nothing more: OND-79's example
 * hides a sale price, and OND-95 asks for "insurer details, policy references,
 * amounts, and documents". A seventh field is one enum value, one `case` arm in
 * `ondo.provenance_chain()` and one revoke.
 *
 * These values must stay in step with the `ondo.provenance_field` enum in the
 * same migration, in the same ORDER: the database rebuilds every stored array
 * with `array_agg(distinct f order by f)`, so the enum's declaration order is
 * the order a rule comes back in and a panel that sorted differently would
 * redraw a saved rule in a different order from the one it was saved in.
 */
export const PROVENANCE_FIELDS = [
    "price",
    "counterparty",
    "insurer",
    "policy_reference",
    "insured_amount",
    "documents",
];
export function isProvenanceField(value) {
    return (typeof value === "string" && PROVENANCE_FIELDS.includes(value));
}
//# sourceMappingURL=disclosure.js.map